<template>
  <li :class="'swiper-slide ' + cellType">
    <a href="#" @click.prevent="()=>sendLogAndGoDetail()" :aria-label="alt">
      <div class="inner-wrap" aria-hidden="true">
        <!--랭킹 밴드에서만 사용하는 랭크 영역-->
        <div class="rank-area" v-if="cellType === 'ranking'">
          <img :src="rankImgUrl" :alt="rankImgAlt">
        </div>

        <div class="picture-area">
          <picture>
            <img :src="getThumbnailImg" @load="onImageLoad" :alt="alt"/>
          </picture>

          <ul class="badge-list">
            <li class="left-top-area">
              <ul v-top-tag-list="{'badgeList': topTagList, 'badgeType': 'artwork'}"></ul>
            </li>
            <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
<!--            <li class="center-bottom-area" v-common-tag-list="{'badgeList': updateTagList, 'type': 'label'}"></li>-->
          </ul>

          <!--TODO:// 썸네일이 없는 경우, 노출되는 타이틀-->
          <div :class="altClassName">
            <span>{{ alt }}</span>
          </div>

          <div class="progress" v-if="isProgress">
            <span class="progress-meter" v-progress-bar="progress * 100">&nbsp;</span>
          </div>
        </div>
        <div class="cell-info" v-if="cellType !== 'ranking'">
          <div class="cell-title-wrap" v-title-list="{'titleList': titleList}"></div>
        </div>
      </div>
    </a>
  </li>
</template>
<script>
import { progressBar, titleList, topTagList, commonTagList } from '@/common/directives'
import { defaultTo, get } from 'lodash'
import cellMixin from '@/common/mixin/cell.mixin'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

export default {
  name: 'PortraitCell',
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    cellIndex: {
      type: Number
    }
  },
  directives: {
    progressBar,
    titleList,
    topTagList,
    commonTagList
  },
  mixins: [
    cellMixin
  ],
  data () {
    return {
      cellType: ''
    }
  },
  computed: {
    rankImgUrl () {
      return require(`../../../../assets/images/home/img_rank_${this.rankValue()}.png`)
    },
    rankImgAlt () {
      return `랭킹 ${this.rankValue(this.cellInfo, this.cellIndex)}위`
    }
  },
  methods: {
    rankValue () {
      const rank = defaultTo(get(this.cellInfo, 'rank', ''), '')
      return rank === '' ? this.cellIndex + 1 : rank
    },
    sendLogAndGoDetail () {
      if (LOG_SEND_LIST.includes(this.$route.name)) {
        this.$emit('cell-click-log', { cellInfo: this.cellInfo, index: this.cellIndex, routeName: this.$route.name })
      }
      this.selectCell()
    }
  },
  created () {
    const cellType = get(this.thumbnailInfo, 'cellType', '')
    if (cellType === 'band_98' || cellType === 'band_94') {
      this.cellType = 'ranking'
    } else if (get(this.cellInfo, 'cta', '').toLowerCase() === 'icon_autoplay') {
      this.cellType = 'watching'
    }
  }
}
</script>
